"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Store all instances of Ink (instance.js) to ensure that consecutive render() calls
// use the same instance of Ink and don't create a new one
//
// This map has to be stored in a separate file, because render.js creates instances,
// but instance.js should delete itself from the map on unmount
exports.default = new WeakMap();
//# sourceMappingURL=instances.js.map